import React from "react";
import "components/generales/Styles.css";

const Error = ({ children }) => {
  return <div className="formulario-error">{children}</div>;
};

export default Error;
